((SocialSharing, $) => {
  'use strict';

  /* eslint-disable */
  const injectPinterestScript = () => {
    var d = document;
    var f = d.getElementsByTagName('SCRIPT')[0], p = d.createElement('SCRIPT');
    p.type = 'text/javascript';
    p.async = true;
    p.src = '//assets.pinterest.com/js/pinit.js';
    f.parentNode.insertBefore(p, f);
  };
  /* eslint-enable */

  const bindUIActions = () => {
    $(document).on('click', '.social-sharing', function run(event) {
      event.preventDefault();
      let articleURL = '';
      let url;
      let imgURL;
      let description;

      if (location.pathname === '/blogs/news/' || location.pathname === '/blogs/news') {
        articleURL = `http://${location.hostname}${$(this).data('share-url')}`;
      } else {
        articleURL = window.location.href;
      }

      switch ($(this).data('network')) {
      case 'facebook':
        window.open(`http://www.facebook.com/sharer/sharer.php?u=${articleURL}`, 'Facebook', 'width=600, height=400, scrollbars=no');
        break;
      case 'twitter':
        window.open(`http://www.twitter.com/intent/tweet?url=${encodeURIComponent(articleURL)}`, 'Tweet', 'width=600, height=400, scrollbars=no');
        break;
      case 'pinterest':
        url = encodeURIComponent(articleURL);
        imgURL = encodeURIComponent($('.product-photo-thumb.slick-active img').attr('src'));
        description = $('.product-description').text();
        window.open(`http://pinterest.com/pin/create/button/?url=${url}&media=${imgURL}&description=${description}`, 'Pinterest', 'width=600, height=400, scrollbars=no');
        break;
      case 'google-plus':
        window.open(`https://plus.google.com/share?url=${encodeURIComponent(articleURL)}`, 'GooglePlus', 'width=680, height=450, scrollbars=no');
      }
    });
  };

  const init = () => {
    bindUIActions();
    injectPinterestScript();
  };

  SocialSharing.init = init;
})(window.SocialSharing = window.SocialSharing || {}, jQuery);
